import getConfig from 'next/config';

/**
 * @param {string} teaserId
 * @param {string | undefined} [language]
 * @returns {any}
 */
function getTeaserDetailById(teaserId, language) {
  const { publicRuntimeConfig } = getConfig();
  const headers = {
    Accept: 'application/json',
    'Accept-Language': language || publicRuntimeConfig.defaultLanguage,
  };

  const fetchUrl = `${publicRuntimeConfig.contentHubBaseUrl}/${teaserId}`;
  return fetch(fetchUrl, {
    headers,
  }).then((res) => {
    return res.json();
  });
}

export default getTeaserDetailById;
